import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Page from '../components/Page';
import { AddpostForm } from '../components/_dashboard/user';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function AddPost() {
  const { t } = useTranslation();

  return (
    <Page title={t('Ajouterpublication')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('Ajouterpublication')}
          </Typography>
        </Stack>

        <Card style={{ display: 'flex', padding: '10px' }}>
          <Container maxWidth="md" style={{ padding: '10px' }}>
            <AddpostForm />
          </Container>
        </Card>
      </Container>
    </Page>
  );
}
